// Lightweight analytics wrapper on top of PostHog (already loaded via index.html)
// Use to capture custom events like landing CTA clicks, upgrades, etc.

export function track(event, props = {}) {
  try {
    if (typeof window !== 'undefined' && window.posthog?.capture) {
      window.posthog.capture(event, props);
    }
  } catch (e) { /* noop */ }
}

export function identify(userId, props = {}) {
  try {
    if (typeof window !== 'undefined' && window.posthog?.identify) {
      window.posthog.identify(userId, props);
    }
  } catch (e) { /* noop */ }
}
